import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHighcharts from "react-highcharts";
import measureSizeEachAttr from "models/MeasureSizeEachAttr";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  verticalWriting: {
    "-webkit-writing-mode": "vertical-rl",
    "-ms-writing-mode": "tb-rl",
    "writing-mode": "vertical-rl"
  }
});

class MeasureSizeEachAttr extends React.Component {
  shouldComponentUpdate(nextProps) {
    return (
      nextProps.columnData !== this.props.columnData ||
      nextProps.lineData !== this.props.lineData ||
      nextProps.title !== this.props.title
    );
  }
  render() {
    return (
      <Fragment>
        <ReactHighcharts
          config={measureSizeEachAttr(
            this.props.columnData,
            this.props.lineData,
            this.props.title,
            this.props.classes
          )}
        />
      </Fragment>
    );
  }
}

MeasureSizeEachAttr.propTypes = {
  columnData: PropTypes.object.isRequired,
  lineData: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired
};

export default withStyles(styles)(MeasureSizeEachAttr);



// WEBPACK FOOTER //
// ./src/components/ReportDetail/MeasureSizeEachAttr.jsx